import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import UserInfoService from "services/AccountInfo/";
import PubSub from 'services/PubSub/';
import Loader from "components/Loader/";
import CartAction from "actions/Cart";
import { cleanSearch } from 'utils';
import {tlfnRegex} from 'config';
import RadioButton from 'components/RadioButton';
import Rut from 'components/Forms/Inputs/InputRut';
import style from './style.scss';//NOSONAR
import { actionsType } from 'config/constants'


let actions = [];
let userInfo = {};
let timeout = null;

const FormUserInfo = ({closeEditUser}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [gender, setGender] = useState(null);
    const [formIsValid, setFormIsValid] = useState(false);
    const [rutIsValid, setRutIsValid] = useState(false);
    const [tlfnIsValid, setTlfnIsValid] = useState(true);
    const [tlfnValue, setTlfnValue] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [rutValue, setRutValue] = useState('');
    const [firstNameshowMessage, setFirstNameshowMessage] = useState(false);
    const [lastNameshowMessage, setLastNameshowMessage] = useState(false)
    const [birthDateError, setBirthDateError] = useState(false);
    const [firstIsValid, setFirstIsValid] = useState(false);
    const [lastNameisValid, setLastNameisValid] = useState(false);
    const [tlfnShowMessage, setTlfnShowMessage] = useState(false);
    let inputMessage = "Campo obligatorio";
    let birthDateMessage = "Debe ingresar una fecha válida";
    const inputDate = useRef(null);
    const inputPhone = useRef(null);
    const inputName = useRef(null);
    const inputLastName = useRef(null);

    useEffect(() => {

        UserInfoService.getUser().then(results => {
            userInfo = results;

            const fecha = userInfo.birthDate ? userInfo.birthDate.substring(0,10): '';
            setIsLoaded(true);
            setGender(userInfo.gender);
            setLastName(userInfo.lastName);
            setFirstName(userInfo.firstName);
            setTlfnValue(userInfo.homePhone);
            setRutValue(userInfo.document ? userInfo.document : '');
            setBirthDate(userInfo.birthDate ? userInfo.birthDate = fecha.slice(-2) +"/"+ fecha.slice(5,7) + "/" + fecha.slice(0,4) : '');
        }, []);



        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];

        }
    }, []);

    useEffect(() => {
        validateForm();
    }, [rutIsValid,tlfnIsValid,firstIsValid, lastNameisValid,gender])

    const updateUser = () => {
        if(formIsValid){

            setIsLoaded(false);


            userInfo.gender = gender;
            if(!userInfo.document){

                userInfo.document = cleanSearch(rutValue.replace( /\s/g, ''));
            }

            userInfo.homePhone = tlfnValue;

            userInfo.firstName = firstName;
            userInfo.lastName = lastName;

            if(birthDate){
                userInfo.birthDate = birthDate.slice(-4) +"/"+birthDate.slice(3,5)+"/"+birthDate.slice(0,2)+"T00:00:00";
            }

            UserInfoService.updateUser(userInfo).then(() => {

                let updateUser = {
                    email: userInfo.email,
                    firstName: userInfo.firstName,
                    lastName: userInfo.lastName,
                    document: userInfo.document,
                    documentType: "RUT",
                    phone: userInfo.homePhone,
                    corporateName: null,
                    tradeName: null,
                    corporateDocument: null,
                    stateInscription: null,
                    corporatePhone: null,
                    isCorporate: false,
                    profileCompleteOnLoading: false,
                    profileErrorOnLoading: false,
                    customerClass: null
                }
                CartAction.setProfileData(updateUser).then(() => {
                    setIsLoaded(true);
                    PubSub.dispatch(actionsType.GET_USER_INFO);
                });
                closeEditUser();
            });


        }
    }

    const changeGender = (value) => {
        setGender(value.currentTarget.value);
    }

    const validateForm = () => {

        let fechaValida = _regexValidarFecha();
        const _tlfnIsValid = validateTlfn(inputPhone.current.value);
        const _lastName = inputName.current.value;
        const _firstName = inputLastName.current.value;

        const isvalid = !!rutIsValid &&
            !!(_lastName.length > 0) &&
            !!(_firstName.length > 0) &&
            !!_tlfnIsValid &&
            !!fechaValida.exec(inputDate.current.value)
            && !!gender;
        if(isvalid !== formIsValid){
            setFormIsValid(isvalid)
        }
    }

    const validateFirst = (value) => {

        if(value.trim().length >= 3){
            setFirstNameshowMessage(false);
            setFirstIsValid(true);
            validateForm();
        }else{
            setFirstNameshowMessage(true);
            setFirstIsValid(false);
            validateForm();
        }
    }

    const validateLast = (value) => {
        if(value.trim().length >= 3){
            setLastNameshowMessage(false)
            setLastNameisValid(true);
            validateForm()
        }else{
            setLastNameshowMessage(true);
            setLastNameisValid(false);
            validateForm();
        }
    }

    const validateTlfn = (value) => {
        if(tlfnRegex.test(value)){
            return true;
        }
        return false;
    }

    const changeFirstName = (value) => {
        validateFirst(value);
        setFirstName(value);
    }

    const changeLastName = (value) => {
        validateLast(value);
        setLastName(value);
    }

    const changeTlfn = (value) => {
        setTlfnShowMessage(false);
        setTlfnValue(value);
        setTlfnIsValid(validateTlfn ? validateTlfn(value) : tlfnIsValid);
        validateForm();

        clearTimeout(timeout);

        if(validateTlfn(value)){
            setTlfnValue(value);
            setTlfnShowMessage(false);
            setTlfnIsValid(true);
            validateForm();
        }else{
            timeout=setTimeout(()=>{
                setTlfnShowMessage(true);
                setTlfnIsValid(false);
                validateForm();
            }, 1000);
        }
    }

    const _regexValidarFecha = () => {
        let sep              = "[/]",

            dia1a28          = "(0[1-9]|1\\d|2[0-8])",
            dia29            = "(29)",
            dia29o30         = "(29|30)",
            dia31            = "(31)",

            mes1a12          = "(0[1-9]|1[0-2])",
            mes2             = "(02)",
            mesNoFeb         = "(0[13-9]|1[0-2])",
            mes31dias        = "(0[13578]|1[02])",

            diames29Feb      = dia29+sep+mes2,
            diames1a28       = dia1a28+sep+mes1a12,
            diames29o30noFeb = dia29o30+sep+mesNoFeb,
            diames31         = dia31+sep+mes31dias,
            diamesNo29Feb    = "(?:"+diames1a28+"|"+diames29o30noFeb+"|"+diames31+")",

            anno1a9999     = "(0{2,3}[1-9]|0{1,2}[1-9]\\d{2}|0?[1-9]\\d{3}|[1-9]\\d{4})",
            annoMult4no100   = "\\d{1,2}(?:0[48]|[2468][048]|[13579][26])",
            annoMult400      = "(?:0?[48]|[13579][26]|[2468][048])00",
            annoBisiesto     = "("+annoMult4no100+"|"+annoMult400+")",

            fechaNo29Feb     = diamesNo29Feb+sep+anno1a9999,
            fecha29Feb       = diames29Feb+sep+annoBisiesto,

            fechaFinal       = "^(?:"+fechaNo29Feb+"|"+fecha29Feb+")$";

        return new RegExp(fechaFinal);
    }

    const changeBirthDate = (value) => {
        let fechaValida = _regexValidarFecha();
        setBirthDate(value);
        validateForm();

        if(value.length < birthDate.length){
            setBirthDateError(false);
            validateForm();
        }else{
            if(value.length == 3){
                if(value.slice(-1) != "/"){
                    setBirthDate(value.slice(0, 2) + "/" + value.slice(2));
                    validateForm();
                }
            }
            if(value.length == 6){
                if(value.slice(-1) != "/"){
                    setBirthDate(value.slice(0, 5) + "/" + value.slice(5));
                    validateForm();
                }
            }
            if(value.length == 10){
                if(!fechaValida.exec(value)){
                    timeout=setTimeout(()=>{
                        setBirthDateError(true);
                        validateForm();
                    },1000);
                }
                if(fechaValida.exec(value)){
                    timeout=setTimeout(()=>{
                        setBirthDateError(false);
                        validateForm();
                    }, 1);
                }
            }
        }

    }

    const blurBirthDate = (value) => {
        let fechaValida = _regexValidarFecha();
        if(!fechaValida.exec(value)){
            timeout=setTimeout(()=>{
                setBirthDateError(true);
                validateForm();
            }, 100)
        }
    }


    const rutValid = (valid, value) => {
        setRutIsValid(valid);
        setRutValue(value);
    }

    return(
        <div className="form-user-info">
            {!isLoaded && <div className="user-info-loader"><Loader /> </div>}
            <div className="input-row">
                <div className={"half-input " + (!firstIsValid && firstNameshowMessage ? 'is-error'  : '')}>
                    <label>Nombre</label>
                    <input ref={inputName} type="text" name="firstName" value={firstName ? firstName : '' } onBlur={ (event) => validateFirst(event.target.value) } onChange={ (event) => changeFirstName(event.target.value)}/>
                    <p className='error'>
                        {  inputMessage }
                    </p>
                </div>
                <div className={"half-input " + (!lastNameisValid && lastNameshowMessage ? 'is-error'  : '')}>
                    <label>Apellido</label>
                    <input ref={inputLastName}type="text" name="lastName" value={lastName ? lastName : ''} onBlur={ (event) => validateLast(event.target.value) } onChange={(event) => changeLastName(event.target.value)}/>
                    <p className='error'>
                        {  inputMessage }
                    </p>
                </div>
            </div>
            <div className="input-row" >
                <div className={"half-input"}>
                    <label className={userInfo.document ? 'disabled' : ''}>RUT {userInfo.document ? <div className="font-icn attention tooltip-container"><span className="tooltip">Por tu seguridad, el RUT puede ser modificado solo a través de Servicio al Cliente</span></div>: ''}</label>
                    <Rut callbackisValid={rutValid} defaultRut={userInfo.document ? userInfo.document : ''}/>
                </div>
                <div className={"half-input " + (birthDateError  ? 'is-error'  : '')}>
                    <label>Fecha de nacimiento</label>
                    <input ref={inputDate} value={birthDate ? birthDate : ''} maxLength="10" name="birth" placeholder="(Ej: 01/01/1981)" onBlur={(event) => blurBirthDate(event.target.value)} onChange={(event) => changeBirthDate(event.target.value) }/>
                    <p className='error'>
                        {  birthDateError ? birthDateMessage : '-'}
                    </p>
                </div>
            </div>
            <div className="input-row">
                <div className="half-input">
                    <label className={'disabled'}>Mail <div className="font-icn attention tooltip-container icon-mail"><span className="tooltip">Por tu seguridad, el mail puede ser modificado solo a través de Servicio al Cliente</span></div></label>
                    <input className={'disabled'} type="email" name="email" defaultValue={userInfo.email} disabled/>
                </div>
                <div className={"half-input " + (!tlfnIsValid && tlfnShowMessage ? 'is-error'  : '')}>
                    <label>Teléfono</label>
                    <input ref={inputPhone} type="tel" name="number" placeholder="(EJ.: +56962768383)" maxLength="12" value={tlfnValue ? tlfnValue : ''} onBlur={ (event) => validateTlfn(event.target.value) }  onChange={ (event) => changeTlfn( event.target.value)}/>
                    <p className='error'>
                        Ingrese un telefono válido
                    </p>
                </div>
            </div>
            <div className="input-row">
                <span className={'gender-title'}>Sexo:</span>
                <div className="gender-checkbox">
                    <div className="checkbox-cont">
                        <label>
                            <RadioButton item={(gender === 'M')} defaultChecked={"M"} name="gender" value="M" callbackSelect={changeGender}  />
                            <span>Masculino</span>
                        </label>
                    </div>
                    <div className="checkbox-cont">
                        <label>
                            <RadioButton item={(gender === 'F')} defaultChecked={"M"} name="gender" value="F" callbackSelect={changeGender}  />
                            <span>Femenino</span>
                        </label>
                    </div>
                </div>
            </div>
            <div className={'box-button'}>
                <button className="secundary-btn" onClick={closeEditUser}>Cancelar</button>
                <button className={(formIsValid ? 'primary-btn' : 'disabled-btn') + (' save-btn')} onClick={updateUser}>Guardar</button>
            </div>
        </div>
    )
}

FormUserInfo.propTypes = {
    basicInfo: PropTypes.object,
    closeEditUser: PropTypes.func
};

export default FormUserInfo;


